import { render, staticRenderFns } from "./account_extract_detail.vue?vue&type=template&id=2d84df8a&scoped=true"
import script from "./account_extract_detail.vue?vue&type=script&lang=js"
export * from "./account_extract_detail.vue?vue&type=script&lang=js"
import style0 from "./account_extract_detail.vue?vue&type=style&index=0&id=2d84df8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84df8a",
  null
  
)

export default component.exports